import { ReactNode } from 'react';

export type Icons = {
  [key: string]: {
    code: ReactNode;
    size: number;
  };
};

export const icons8: Icons = {
  '8-link-external': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 0C7.00646 0 7.01291 6.10855e-05 7.01934 0.000183105C7.04268 0.000634695 7.066 0.0018949 7.08925 0.00396633C7.1097 0.00574788 7.12942 0.00810087 7.14896 0.0110192C7.16595 0.013628 7.18337 0.0167024 7.20073 0.0202403C7.22275 0.02464 7.24444 0.0298335 7.26584 0.0357208C7.28146 0.0400976 7.29685 0.0447286 7.31214 0.0497379C7.3318 0.0561223 7.35158 0.0633158 7.37106 0.071104C7.3888 0.0781965 7.4061 0.0856789 7.42322 0.0936732C7.44389 0.103377 7.46429 0.113794 7.48428 0.124876C7.49639 0.131499 7.50861 0.138607 7.52071 0.145996C7.54381 0.160211 7.56634 0.17527 7.58819 0.191193C7.59804 0.198285 7.60758 0.205509 7.61702 0.212928C7.68018 0.262552 7.73745 0.319818 7.78721 0.38325L7.70711 0.292893C7.74191 0.327693 7.7736 0.364418 7.8022 0.402728C7.82059 0.427502 7.83785 0.45302 7.85393 0.47934C7.86139 0.491387 7.8685 0.503605 7.87533 0.515938C7.88533 0.534127 7.89497 0.552886 7.90403 0.571979C7.91284 0.590498 7.92112 0.609487 7.92877 0.628664C7.93668 0.648421 7.94388 0.668202 7.95045 0.688263C7.95527 0.703148 7.9599 0.718537 7.96416 0.734007C7.97017 0.755563 7.97536 0.777254 7.97983 0.799206C7.9833 0.816625 7.98637 0.834051 7.98898 0.851533C7.99624 0.899638 8 0.94938 8 1L7.9963 0.913769C7.99784 0.931735 7.99891 0.949734 7.99948 0.967745L8 1V5C8 5.8909 6.92286 6.33707 6.29289 5.70711L5 4.415L1.70711 7.70711C1.31658 8.09763 0.683418 8.09763 0.292893 7.70711C-0.0675905 7.34662 -0.0953204 6.77939 0.209704 6.3871L0.292893 6.29289L3.585 3L2.29289 1.70711C1.69032 1.10453 2.07233 0.0928193 2.88637 0.00598335L3 0H7Z"
        fill="currentColor"
      />
    ),
    size: 8,
  },
};

export const icons12: Icons = {
  '12-create': {
    code: (
      <>
        <path
          d="M11.56.44a1.5 1.5 0 0 0-2.12 0L3.75 6.128V8.25h2.121l5.69-5.69a1.5 1.5 0 0 0 0-2.12Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 3a1.5 1.5 0 0 1 1.5-1.5h3a.75.75 0 0 1 0 1.5h-3v7.5H9v-3a.75.75 0 0 1 1.5 0v3A1.5 1.5 0 0 1 9 12H1.5A1.5 1.5 0 0 1 0 10.5V3Z"
          fill="currentColor"
        />
      </>
    ),
    size: 12,
  },
  '12-plus': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 5H7V1a1 1 0 1 0-2 0v4H1a1 1 0 1 0 0 2h4v4a1 1 0 1 0 2 0V7h4a1 1 0 1 0 0-2Z"
        fill="currentColor"
      />
    ),
    size: 12,
  },
  '12-minus': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 5a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H2Z"
        fill="currentColor"
      />
    ),
    size: 12,
  },
  '12-arrow': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.993 6.117a1.116 1.116 0 0 1-.057.237 1.164 1.164 0 0 1-.051.112l-.013.024-.011.019c-.014.024-.03.048-.046.071l-.015.02-3 4a1 1 0 0 1-1.669-1.095L7.2 9.4 9 7H1a1 1 0 0 1-.117-1.993L1 5h8L7.2 2.6a1 1 0 0 1 1.519-1.296L8.8 1.4l3 4 .02.028c.014.02.028.04.04.062l-.06-.09a1.007 1.007 0 0 1 .193.48v.003L12 6l-.007.117Z"
        fill="currentColor"
      />
    ),
    size: 12,
  },
  '12-document': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.786 0 10 3.333v7.334C10 11.403 9.424 12 8.714 12H2.286C1.576 12 1 11.403 1 10.667V1.333C1 .597 1.576 0 2.286 0h4.5Z"
        fill="currentColor"
      />
    ),
    size: 12,
  },
  '12-check': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10a.993.993 0 0 1-.707-.293l-3-3a.999.999 0 1 1 1.414-1.414L4.933 7.52l4.298-5.16a1.003 1.003 0 0 1 1.41-.128c.423.354.48.985.128 1.41l-5 6a1.007 1.007 0 0 1-.724.358L5 10Z"
        fill="currentColor"
      />
    ),
    size: 12,
  },
  '12-close': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m7.414 6 3.293-3.293a.999.999 0 1 0-1.414-1.414L6 4.586 2.707 1.293a.999.999 0 1 0-1.414 1.414L4.586 6 1.293 9.293a.999.999 0 1 0 1.414 1.414L6 7.414l3.293 3.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L7.414 6Z"
        fill="currentColor"
      />
    ),
    size: 12,
  },
  '12-shipped': {
    code: (
      <path
        d="M4 9C4 8.75926 3.91204 8.55093 3.73611 8.375C3.56019 8.19907 3.35185 8.11111 3.11111 8.11111C2.87037 8.11111 2.66204 8.19907 2.48611 8.375C2.31019 8.55093 2.22222 8.75926 2.22222 9C2.22222 9.24074 2.31019 9.44907 2.48611 9.625C2.66204 9.80093 2.87037 9.88889 3.11111 9.88889C3.35185 9.88889 3.56019 9.80093 3.73611 9.625C3.91204 9.44907 4 9.24074 4 9ZM1.33333 5.44444H4V3.66667H2.90278C2.84259 3.66667 2.79167 3.6875 2.75 3.72917L1.39583 5.08333C1.35417 5.125 1.33333 5.17593 1.33333 5.23611V5.44444ZM10.2222 9C10.2222 8.75926 10.1343 8.55093 9.95833 8.375C9.78241 8.19907 9.57407 8.11111 9.33333 8.11111C9.09259 8.11111 8.88426 8.19907 8.70833 8.375C8.53241 8.55093 8.44444 8.75926 8.44444 9C8.44444 9.24074 8.53241 9.44907 8.70833 9.625C8.88426 9.80093 9.09259 9.88889 9.33333 9.88889C9.57407 9.88889 9.78241 9.80093 9.95833 9.625C10.1343 9.44907 10.2222 9.24074 10.2222 9ZM12 1.44444V8.55556C12 8.625 11.9907 8.68634 11.9722 8.73958C11.9537 8.79282 11.9225 8.83565 11.8785 8.86806C11.8345 8.90046 11.7963 8.92708 11.7639 8.94792C11.7315 8.96875 11.6771 8.98264 11.6007 8.98958C11.5243 8.99653 11.4722 9.00116 11.4444 9.00347C11.4167 9.00579 11.3576 9.00579 11.2674 9.00347C11.1771 9.00116 11.125 9 11.1111 9C11.1111 9.49074 10.9375 9.90972 10.5903 10.2569C10.2431 10.6042 9.82407 10.7778 9.33333 10.7778C8.84259 10.7778 8.42361 10.6042 8.07639 10.2569C7.72917 9.90972 7.55556 9.49074 7.55556 9H4.88889C4.88889 9.49074 4.71528 9.90972 4.36806 10.2569C4.02083 10.6042 3.60185 10.7778 3.11111 10.7778C2.62037 10.7778 2.20139 10.6042 1.85417 10.2569C1.50694 9.90972 1.33333 9.49074 1.33333 9H0.888889C0.875 9 0.822917 9.00116 0.732639 9.00347C0.642361 9.00579 0.583333 9.00579 0.555556 9.00347C0.527778 9.00116 0.475694 8.99653 0.399306 8.98958C0.322917 8.98264 0.268519 8.96875 0.236111 8.94792C0.203704 8.92708 0.165509 8.90046 0.121528 8.86806C0.0775463 8.83565 0.0462963 8.79282 0.0277778 8.73958C0.00925926 8.68634 0 8.625 0 8.55556C0 8.43519 0.0439815 8.33102 0.131944 8.24306C0.219907 8.15509 0.324074 8.11111 0.444444 8.11111V5.88889C0.444444 5.85185 0.443287 5.77083 0.440972 5.64583C0.438657 5.52083 0.438657 5.43287 0.440972 5.38194C0.443287 5.33102 0.449074 5.25116 0.458333 5.14236C0.467593 5.03356 0.482639 4.94792 0.503472 4.88542C0.524306 4.82292 0.556713 4.75231 0.600694 4.67361C0.644676 4.59491 0.696759 4.52546 0.756944 4.46528L2.13194 3.09028C2.21991 3.00231 2.33681 2.92824 2.48264 2.86806C2.62847 2.80787 2.76389 2.77778 2.88889 2.77778H4V1.44444C4 1.32407 4.04398 1.21991 4.13194 1.13194C4.21991 1.04398 4.32407 1 4.44444 1H11.5556C11.6759 1 11.7801 1.04398 11.8681 1.13194C11.956 1.21991 12 1.32407 12 1.44444Z"
        fill="currentColor"
      />
    ),
    size: 12,
  },
  '12-packing': {
    code: (
      <>
        <path
          d="M10.8193 2.70294C10.8193 2.59848 10.7671 2.54625 10.7148 2.49402L6.48416 0.039173C6.43193 -0.0130577 6.32747 -0.0130577 6.22301 0.039173L1.94009 2.49402C1.88786 2.54625 1.83563 2.59848 1.83563 2.70294C1.83563 2.8074 1.88786 2.85963 1.94009 2.91186L6.17078 5.3667C6.22301 5.3667 6.27524 5.41893 6.27524 5.41893C6.27524 5.41893 6.3797 5.41893 6.3797 5.3667L10.6104 2.91186C10.7671 2.85963 10.8193 2.75517 10.8193 2.70294Z"
          fill="currentColor"
        />
        <path
          d="M5.5963 6.62025L1.36561 4.16541C1.26115 4.11318 1.15669 4.11318 1.10446 4.16541C1.05223 4.21764 1 4.3221 1 4.37433V9.28402C1 9.38848 1.05223 9.44071 1.10446 9.49294L5.33515 11.9478C5.38738 11.9478 5.43961 12 5.43961 12C5.43961 12 5.54407 12 5.54407 11.9478C5.5963 11.8956 5.64853 11.8433 5.64853 11.7389V6.82917C5.75299 6.72471 5.70076 6.67248 5.5963 6.62025Z"
          fill="currentColor"
        />
        <path
          d="M11.5508 4.16541C11.4985 4.11318 11.3941 4.11318 11.2896 4.16541L7.05893 6.62025C7.0067 6.67248 6.95447 6.72471 6.95447 6.82917V11.7389C6.95447 11.8433 7.0067 11.8956 7.05893 11.9478C7.11116 11.9478 7.16339 12 7.16339 12C7.16339 12 7.26785 12 7.26785 11.9478L11.4985 9.49294C11.5508 9.44071 11.603 9.38848 11.603 9.28402V4.37433C11.6552 4.3221 11.603 4.21764 11.5508 4.16541Z"
          fill="currentColor"
        />
      </>
    ),
    size: 12,
  },
  '12-arrow-right': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9933 5.11656C11.9905 5.13884 11.9876 5.15823 11.9841 5.17754C11.9807 5.19761 11.9766 5.21711 11.9719 5.23638C11.9669 5.25627 11.9614 5.27611 11.9553 5.29581C11.9495 5.31536 11.9428 5.33465 11.9356 5.35366C11.9289 5.37083 11.9221 5.3876 11.9147 5.40422C11.9056 5.42525 11.8956 5.44592 11.8849 5.46617C11.8806 5.47393 11.8764 5.48176 11.872 5.48954L11.861 5.50891C11.8465 5.53333 11.831 5.55709 11.8146 5.58012L11.8 5.59994L8.8 9.59994C8.46863 10.0418 7.84183 10.1313 7.4 9.79994C6.99216 9.49406 6.88449 8.93645 7.13097 8.50497L7.2 8.39994L9 6L1 5.99994C0.447715 5.99994 0 5.55223 0 4.99994C0 4.48711 0.38604 4.06443 0.883379 4.00667L1 3.99994L9 4L7.2 1.59994C6.86863 1.15811 6.95817 0.531311 7.4 0.199941C7.80784 -0.10594 8.37329 -0.0531731 8.7185 0.304265L8.8 0.39994L11.8 4.39994L11.8203 4.42784C11.8344 4.44803 11.8478 4.46876 11.8604 4.49L11.8 4.39994C11.8321 4.44279 11.8604 4.48758 11.8848 4.53383C11.8956 4.55397 11.9056 4.57463 11.9149 4.59568C11.9221 4.61228 11.9289 4.62905 11.9353 4.64596C11.9428 4.66523 11.9495 4.68452 11.9555 4.70406C11.9614 4.72377 11.9669 4.74362 11.9717 4.76358C11.9766 4.78278 11.9807 4.80227 11.9842 4.82196C11.9876 4.84167 11.9905 4.86107 11.9929 4.88054C11.993 4.88129 11.9932 4.8823 11.9933 4.88332L12 4.99994L11.9933 5.11656Z"
        fill="currentColor"
      />
    ),
    size: 12,
  },

  '12-package': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.51,2.7a.31.31,0,0,0-.11-.21L6.17,0a.24.24,0,0,0-.26,0L1.63,2.49a.31.31,0,0,0-.11.21.27.27,0,0,0,.11.21L5.86,5.37a.17.17,0,0,1,.1,0s.11,0,.11,0L10.3,2.91C10.45,2.86,10.51,2.76,10.51,2.7Z M5.28,6.62,1.05,4.17a.21.21,0,0,0-.26,0,.38.38,0,0,0-.1.2V9.28a.26.26,0,0,0,.1.21L5,12a.18.18,0,0,1,.11.05s.1,0,.1-.05a.29.29,0,0,0,.11-.21V6.83C5.44,6.72,5.39,6.67,5.28,6.62Z M11.24,4.17a.21.21,0,0,0-.26,0L6.75,6.62a.25.25,0,0,0-.11.21v4.91a.26.26,0,0,0,.11.21.17.17,0,0,1,.1.05S7,12,7,12l4.23-2.46a.26.26,0,0,0,.1-.21V4.37C11.34,4.32,11.29,4.22,11.24,4.17Z"
        fill="currentColor"
      />
    ),
    size: 12,
  },
  '12-truck': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4,9.11a.85.85,0,0,0-.26-.62.86.86,0,0,0-.63-.27.83.83,0,0,0-.62.27.83.83,0,0,0-.27.62.86.86,0,0,0,.27.63.85.85,0,0,0,.62.26A.89.89,0,0,0,4,9.11ZM1.33,5.56H4V3.78H2.9a.2.2,0,0,0-.15.06L1.4,5.19a.21.21,0,0,0-.07.16Zm8.89,3.55A.85.85,0,0,0,10,8.49a.86.86,0,0,0-.63-.27.92.92,0,0,0-.89.89.86.86,0,0,0,.27.63.85.85,0,0,0,.62.26.89.89,0,0,0,.89-.89ZM12,1.56V8.67a.48.48,0,0,1,0,.18.3.3,0,0,1-.09.13l-.12.08a.4.4,0,0,1-.16,0h-.49a1.78,1.78,0,0,1-1.78,1.78,1.68,1.68,0,0,1-1.25-.52,1.71,1.71,0,0,1-.52-1.26H4.89a1.71,1.71,0,0,1-.52,1.26,1.71,1.71,0,0,1-1.26.52,1.71,1.71,0,0,1-1.26-.52,1.75,1.75,0,0,1-.52-1.26H.4a.4.4,0,0,1-.16,0L.12,9A.3.3,0,0,1,0,8.85a.48.48,0,0,1,0-.18.44.44,0,0,1,.13-.32.46.46,0,0,1,.31-.13V5.49s0-.13,0-.24A1.18,1.18,0,0,1,.5,5a1.38,1.38,0,0,1,.1-.22,1,1,0,0,1,.16-.2L2.13,3.2A1.1,1.1,0,0,1,2.48,3a1.09,1.09,0,0,1,.41-.09H4V1.56a.44.44,0,0,1,.13-.32.46.46,0,0,1,.31-.13h7.12a.46.46,0,0,1,.31.13A.44.44,0,0,1,12,1.56Z"
        fill="currentColor"
      />
    ),
    size: 12,
  },
};

export const icons16: Icons = {
  '16-alert-solid': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4C7.44772 4 7 4.44772 7 5V8C7 8.55228 7.44772 9 8 9C8.55228 9 9 8.55228 9 8V5C9 4.44772 8.55228 4 8 4ZM8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10ZM8 2C4.686 2 2 4.687 2 8C2 11.314 4.686 14 8 14C11.313 14 14 11.314 14 8C14 4.687 11.313 2 8 2Z"
        fill="currentColor"
      />
    ),
    size: 16,
  },
  '16-arrowhead': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.53342 5.23861C7.75538 4.92046 8.24462 4.92046 8.46658 5.23861L11.9049 10.1669C12.1533 10.523 11.8862 11 11.4383 11H4.5617C4.11383 11 3.84668 10.523 4.09512 10.1669L7.53342 5.23861Z"
        fill="currentColor"
      />
    ),
    size: 16,
  },
  '16-document': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.6 0.800049L13.6 4.80005V13.6C13.6 14.4837 12.8837 15.2 12 15.2H4C3.11635 15.2 2.4 14.4837 2.4 13.6V2.40005C2.4 1.51639 3.11635 0.800049 4 0.800049H9.6ZM8.8 2.40005H4V13.6H12V5.60005H8.8V2.40005Z"
        fill="currentColor"
      />
    ),
    size: 16,
  },
  '16-delete': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6V12C12 13.1046 11.1046 14 10 14H6C4.89543 14 4 13.1046 4 12V6H12ZM9.5 2L10.5 3H12C12.5523 3 13 3.44772 13 4C13 4.55228 12.5523 5 12 5H4C3.44772 5 3 4.55228 3 4C3 3.44772 3.44772 3 4 3H5.5L6.5 2H9.5Z"
        fill="currentColor"
      />
    ),
    size: 16,
  },
  '16-check': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.91006 10.4959L3.7071 8.29291C3.31658 7.90239 2.68342 7.90239 2.29289 8.29291C1.90237 8.68343 1.90237 9.3166 2.29289 9.70712L5.29288 12.7071C5.7168 13.131 6.4159 13.0892 6.7863 12.6178L13.7863 4.61786C14.1275 4.18359 14.0521 3.55494 13.6178 3.21372C13.1835 2.87251 12.5549 2.94795 12.2136 3.38222L5.91006 10.4959Z"
        fill="currentColor"
      />
    ),
    size: 16,
  },
  '16-close': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m9.414 8 3.293-3.293a.999.999 0 1 0-1.414-1.414L8 6.586 4.707 3.293a.999.999 0 1 0-1.414 1.414L6.586 8l-3.293 3.293a.999.999 0 1 0 1.414 1.414L8 9.414l3.293 3.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L9.414 8Z"
        fill="currentColor"
      />
    ),
    size: 16,
  },
};

export const icons18: Icons = {
  '18-search': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 7C2 4.243 4.243 2 7 2C9.757 2 12 4.243 12 7C12 9.757 9.757 12 7 12C4.243 12 2 9.757 2 7ZM17.707 16.293L12.601 11.187C13.476 10.018 14 8.572 14 7C14 3.134 10.866 0 7 0C3.134 0 0 3.134 0 7C0 10.866 3.134 14 7 14C8.572 14 10.018 13.476 11.187 12.601L16.293 17.707C16.488 17.902 16.744 18 17 18C17.256 18 17.512 17.902 17.707 17.707C18.098 17.316 18.098 16.684 17.707 16.293Z"
        fill="currentColor"
      />
    ),
    size: 18,
  },
};

export const icons20: Icons = {
  '20-arrow-right': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 10C2 9.44772 2.44772 9 3 9H14.585L12.2929 6.70711C11.9324 6.34662 11.9047 5.77939 12.2097 5.3871L12.2929 5.29289C12.6534 4.93241 13.2206 4.90468 13.6129 5.2097L13.7071 5.29289L17.7071 9.29289L17.7485 9.33685V9.33685L17.8037 9.40469V9.40469L17.8753 9.51594V9.51594L17.9288 9.62866V9.62866L17.9642 9.73401V9.73401L17.9932 9.88253V9.88253L18 10L17.9972 10.0752V10.0752L17.9798 10.2007V10.2007L17.9503 10.3121V10.3121L17.9063 10.4232V10.4232L17.854 10.5207V10.5207L17.7872 10.6168C17.7623 10.6485 17.7356 10.6786 17.7071 10.7071L13.7071 14.7071C13.3166 15.0976 12.6834 15.0976 12.2929 14.7071C11.9324 14.3466 11.9047 13.7794 12.2097 13.3871L12.2929 13.2929L14.585 11H3C2.44772 11 2 10.5523 2 10Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-chart': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 16H16V2H2V16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM5 8C5.55228 8 6 8.44771 6 9V13C6 13.5523 5.55228 14 5 14C4.44772 14 4 13.5523 4 13V9C4 8.44771 4.44772 8 5 8ZM9 4C9.55228 4 10 4.44772 10 5V13C10 13.5523 9.55228 14 9 14C8.44771 14 8 13.5523 8 13V5C8 4.44772 8.44771 4 9 4ZM13 10C13.5523 10 14 10.4477 14 11V13C14 13.5523 13.5523 14 13 14C12.4477 14 12 13.5523 12 13V11C12 10.4477 12.4477 10 13 10Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-filter': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h4Zm3-6a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h10Zm3-6a1 1 0 1 1 0 2H2a1 1 0 0 1 0-2h16Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-home': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.29289 1.29289C9.68342 0.902369 10.3166 0.902369 10.7071 1.29289L17.7071 8.29289C17.8946 8.48043 18 8.73478 18 9V18C18 18.5523 17.5523 19 17 19H3C2.44772 19 2 18.5523 2 18V9C2 8.73478 2.10536 8.48043 2.29289 8.29289L9.29289 1.29289ZM10 3.415L4 9.414V17H8V13C8 12.4477 8.44772 12 9 12H11C11.5523 12 12 12.4477 12 13V17H16V9.415L10 3.415Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-lock': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 11C8.55228 11 9 11.4477 9 12V13C9 13.5523 8.55228 14 8 14C7.44772 14 7 13.5523 7 13V12C7 11.4477 7.44772 11 8 11ZM2 7C0.9 7 0.00999999 7.9 0.00999999 9L0 16C0 17.1 0.9 18 2 18H14C15.1 18 16 17.1 16 16V9C16 7.9 15.1 7 14 7H2ZM14 9V16H2V9H14ZM8 0C10.7614 0 13 2.23858 13 5V7H11V5C11 3.34315 9.65685 2 8 2C6.40232 2 5.09634 3.24892 5.00509 4.82373L5 5V7H3V5C3 2.23858 5.23858 0 8 0Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-plus': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 4V9H4C3.44772 9 3 9.44772 3 10C3 10.5523 3.44772 11 4 11H9V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V11H16C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9H11V4C11 3.44772 10.5523 3 10 3C9.44772 3 9 3.44772 9 4Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-orders': {
    code: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 1C18.1046 1 19 1.89543 19 3V7C19 8.10457 18.1046 9 17 9H3C1.89543 9 1 8.10457 1 7V3C1 1.89543 1.89543 1 3 1H17ZM17 3H3V7H17V3Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 11C18.1046 11 19 11.8954 19 13V17C19 18.1046 18.1046 19 17 19H3C1.89543 19 1 18.1046 1 17V13C1 11.8954 1.89543 11 3 11H17ZM17 13H3V17H17V13Z"
          fill="currentColor"
        />
      </>
    ),
    size: 20,
  },
  '20-cart': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 16C5.32843 16 6 16.6716 6 17.5C6 18.3284 5.32843 19 4.5 19C3.67157 19 3 18.3284 3 17.5C3 16.6716 3.67157 16 4.5 16ZM14.5 16C15.3284 16 16 16.6716 16 17.5C16 18.3284 15.3284 19 14.5 19C13.6716 19 13 18.3284 13 17.5C13 16.6716 13.6716 16 14.5 16ZM4 1C4.55228 1 5 1.44772 5 2V4H18C18.6982 4 19.1815 4.69737 18.9363 5.35112L15.9363 13.3511C15.79 13.7414 15.4168 14 15 14H6C4.34315 14 3 12.6569 3 11V5V4.983V3H2C1.44772 3 1 2.55228 1 2C1 1.44772 1.44772 1 2 1H4ZM16.557 6H5V11C5 11.5523 5.44772 12 6 12H14.307L16.557 6Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-settings': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 1C11.5523 1 12 1.44772 12 2L12.0004 2.25213C12.7343 2.44106 13.4274 2.73152 14.064 3.10765L14.2426 2.92893C14.6332 2.53841 15.2663 2.53841 15.6569 2.92893L17.0711 4.34315C17.4616 4.73367 17.4616 5.36684 17.0711 5.75736L16.8923 5.93604C17.2686 6.57286 17.5592 7.26635 17.7481 8.00064L18 8C18.5523 8 19 8.44772 19 9V11C19 11.5523 18.5523 12 18 12L17.7479 12.0004C17.5589 12.7343 17.2685 13.4274 16.8923 14.064L17.0711 14.2426C17.4616 14.6332 17.4616 15.2663 17.0711 15.6569L15.6569 17.0711C15.2663 17.4616 14.6332 17.4616 14.2426 17.0711L14.064 16.8923C13.4274 17.2685 12.7343 17.5589 12.0004 17.7479L12 18C12 18.5523 11.5523 19 11 19H9C8.44772 19 8 18.5523 8 18L8.00064 17.7481C7.26635 17.5592 6.57286 17.2686 5.93604 16.8923L5.75736 17.0711C5.36684 17.4616 4.73367 17.4616 4.34315 17.0711L2.92893 15.6569C2.53841 15.2663 2.53841 14.6332 2.92893 14.2426L3.10765 14.064C2.73152 13.4274 2.44106 12.7343 2.25213 12.0004L2 12C1.44772 12 1 11.5523 1 11V9C1 8.44772 1.44772 8 2 8L2.25187 8.00064C2.4408 7.26635 2.73135 6.57286 3.10765 5.93604L2.92893 5.75736C2.53841 5.36684 2.53841 4.73367 2.92893 4.34315L4.34315 2.92893C4.73367 2.53841 5.36684 2.53841 5.75736 2.92893L5.93604 3.10765C6.57286 2.73135 7.26635 2.4408 8.00064 2.25187L8 2C8 1.44772 8.44772 1 9 1H11ZM10 3C9.44772 3 9 3.44772 9 4C9 4.02823 9.00117 4.05618 9.00346 4.08381C8.08916 4.2351 7.24425 4.59503 6.51928 5.11224L6.46447 5.05025C6.07394 4.65973 5.44078 4.65973 5.05025 5.05025C4.65973 5.44078 4.65973 6.07394 5.05025 6.46447C5.07007 6.48428 5.0905 6.50309 5.1115 6.52089C4.59503 7.24425 4.2351 8.08916 4.08226 9.00419L4 9C3.44772 9 3 9.44772 3 10C3 10.5523 3.44772 11 4 11C4.02823 11 4.05618 10.9988 4.08381 10.9965C4.2351 11.9108 4.59503 12.7558 5.11224 13.4807L5.05025 13.5355C4.65973 13.9261 4.65973 14.5592 5.05025 14.9497C5.44078 15.3403 6.07394 15.3403 6.46447 14.9497C6.48428 14.9299 6.50309 14.9095 6.52089 14.8885C7.24425 15.405 8.08916 15.7649 9.00419 15.9177L9 16C9 16.5523 9.44772 17 10 17L10.1166 16.9933C10.614 16.9355 11 16.5128 11 16L10.9965 15.9159C11.9108 15.7649 12.7558 15.405 13.4807 14.8878L13.5355 14.9497C13.9261 15.3403 14.5592 15.3403 14.9497 14.9497C15.3403 14.5592 15.3403 13.9261 14.9497 13.5355C14.9299 13.5157 14.9095 13.4969 14.8885 13.4791C15.405 12.7557 15.7649 11.9108 15.9177 10.9958L16 11C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9C15.9717 9 15.9436 9.00118 15.9159 9.00349C15.7649 8.08916 15.405 7.24425 14.8878 6.51928L14.9497 6.46447C15.3403 6.07394 15.3403 5.44078 14.9497 5.05025C14.5592 4.65973 13.9261 4.65973 13.5355 5.05025C13.5157 5.07007 13.4969 5.0905 13.4791 5.1115C12.7557 4.59503 11.9108 4.2351 10.9958 4.08226L11 4C11 3.44772 10.5523 3 10 3ZM10 6C12.2091 6 14 7.79086 14 10C14 12.2091 12.2091 14 10 14C7.79086 14 6 12.2091 6 10C6 7.79086 7.79086 6 10 6ZM10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-download': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 12C17.5523 12 18 12.4477 18 13V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V13L0.0067277 12.8834C0.0644928 12.386 0.487164 12 1 12C1.55228 12 2 12.4477 2 13V16H16V13L16.0067 12.8834C16.06 12.4243 16.4243 12.0601 16.8834 12.0067L17 12ZM9 0C9.55228 0 10 0.447715 10 1V10.17L11.8836 8.29364C12.274 7.90481 12.9054 7.90542 13.295 8.295C13.6844 8.68436 13.6844 9.31564 13.295 9.705L9.70711 13.2929C9.31658 13.6834 8.68342 13.6834 8.29289 13.2929L4.7075 9.7075C4.31636 9.31636 4.31524 8.68253 4.705 8.29C5.09685 7.89814 5.72814 7.89814 6.1175 8.2875L8 10.17V1C8 0.447715 8.44771 0 9 0Z"
        fill="#0071CE"
      />
    ),
    size: 20,
  },
  '20-email': {
    code: (
      <path
        d="M16.8571 3C18.0684 3 19 4.04759 19 5.28571V14.7143C19 15.9518 18.0682 17 16.8571 17H3.14286C1.93176 17 1 15.9518 1 14.7143V5.28571C1 4.04759 1.93162 3 3.14286 3H16.8571ZM17 6.33L10.669 12.029C10.3204 12.3428 9.80619 12.3689 9.42999 12.1074L9.33104 12.029L3 6.331V14.7143C3 14.8659 3.06405 14.9632 3.1147 14.9915L3.14286 15H16.8571C16.9078 15 17 14.8962 17 14.7143V6.33ZM15.489 5H4.51L9.999 9.94L15.489 5Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-documents': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1L17 6V17C17 18.1046 16.1046 19 15 19H5C3.89543 19 3 18.1046 3 17V3C3 1.89543 3.89543 1 5 1H12ZM11 3H5V17H15V7H11V3Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-documents-add': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0L14 5V10H12V6H8V2H2V16H8V18H2C0.89543 18 0 17.1046 0 16V2C0 0.89543 0.89543 0 2 0H9ZM13 12C13.5523 12 14 12.4477 14 13V14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H14V17C14 17.5523 13.5523 18 13 18C12.4477 18 12 17.5523 12 17V15.999L11 16C10.4477 16 10 15.5523 10 15C10 14.4477 10.4477 14 11 14L12 13.999V13C12 12.4477 12.4477 12 13 12Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-megaphone': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 10.9033C16 11.2363 15.863 11.5463 15.625 11.7553C15.424 11.9323 15.174 12.0173 14.916 11.9913L6 10.0503V3.99626C6 3.97826 5.991 3.96326 5.99 3.94526L14.882 2.00426C15.151 1.96826 15.415 2.05126 15.625 2.23626C15.863 2.44526 16 2.75626 16 3.08926V10.9033ZM8 12.6823C8 13.1583 7.809 13.5863 7.488 13.8263C7.34 13.9373 7.104 14.0523 6.786 13.9593C6.331 13.8273 6 13.2873 6 12.6763V12.0953L8.029 12.5373C8.022 12.5873 8 12.6313 8 12.6823ZM2 8.28726V5.70426C2 5.15226 2.379 4.68526 2.965 4.60526L4 4.37926V9.61526L2.881 9.37226C2.379 9.30626 2 8.84026 2 8.28726ZM16.945 0.734264C16.304 0.171264 15.459 -0.088736 14.539 0.035264L2.623 2.63626C1.127 2.83226 0 4.15126 0 5.70426V8.28726C0 9.84126 1.127 11.1593 2.539 11.3403L4 11.6593V12.6763C4 14.1813 4.917 15.4993 6.248 15.8863C6.5 15.9593 6.756 15.9953 7.012 15.9953C7.604 15.9953 8.189 15.8003 8.688 15.4263C9.439 14.8623 9.893 13.9533 9.969 12.9603L14.539 13.9563L14.622 13.9713C14.748 13.9873 14.873 13.9953 14.999 13.9953C15.707 13.9953 16.4 13.7363 16.945 13.2583C17.615 12.6703 18 11.8113 18 10.9033V3.08926C18 2.18026 17.615 1.32226 16.945 0.734264Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-collapse': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 1C18.5523 1 19 1.44772 19 2V18C19 18.5523 18.5523 19 18 19C17.4477 19 17 18.5523 17 18V2C17 1.44772 17.4477 1 18 1ZM7.29247 3.7075C7.68361 3.31636 8.31744 3.31524 8.70997 3.705C9.10183 4.09685 9.10183 4.72814 8.71247 5.1175L4.82997 9H14C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11H4.82997L8.70574 14.8842C9.0948 15.2741 9.09446 15.9055 8.70497 16.295C8.31561 16.6844 7.68433 16.6844 7.29497 16.295L1.70708 10.7071C1.31655 10.3166 1.31655 9.68342 1.70708 9.29289L7.29247 3.7075Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-user': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 12H13C15.7614 12 18 14.2386 18 17C18 17.5523 17.5523 18 17 18C16.4872 18 16.0645 17.614 16.0067 17.1166L15.9949 16.8237C15.907 15.3072 14.6928 14.093 13.1763 14.0051L13 14H7C5.34315 14 4 15.3431 4 17C4 17.5523 3.55228 18 3 18C2.44772 18 2 17.5523 2 17C2 14.3112 4.12231 12.1182 6.78311 12.0046L7 12H13H7ZM10 2C12.7614 2 15 4.23858 15 7C15 9.76142 12.7614 12 10 12C7.23858 12 5 9.76142 5 7C5 4.23858 7.23858 2 10 2ZM10 4C8.34315 4 7 5.34315 7 7C7 8.65685 8.34315 10 10 10C11.6569 10 13 8.65685 13 7C13 5.34315 11.6569 4 10 4Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-bookmark': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.65079 17.7573C5.00212 18.3133 4 17.8524 4 16.9982V4.99971C4 3.34302 5.34315 2 7 2H13C14.6569 2 16 3.34302 16 4.99971V16.9982C16 17.8524 14.9979 18.3133 14.3492 17.7573L10 14.3157L5.65079 17.7573ZM14 14.8242V4.99971C14 4.44748 13.5523 3.99981 13 3.99981H7C6.44772 3.99981 6 4.44748 6 4.99971V14.8242L9.34921 12.2396C9.7237 11.9186 10.2763 11.9186 10.6508 12.2396L14 14.8242Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-more': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7,9c0,1.1,0.9,2,2,2s2-0.9,2-2s-0.9-2-2-2S7,7.9,7,9z M14,9c0,1.1,0.9,2,2,2s2-0.9,2-2s-0.9-2-2-2S14,7.9,14,9
	z M0,9c0,1.1,0.9,2,2,2s2-0.9,2-2S3.1,7,2,7S0,7.9,0,9z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-company': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 2C10.3837 2 11.5486 2.93681 11.8951 4.21078C12.2361 4.07468 12.6093 4 13 4H15C16.6569 4 18 5.34315 18 7V15C18 16.6569 16.6569 18 15 18H5C3.34315 18 2 16.6569 2 15V5C2 3.34315 3.34315 2 5 2H9ZM9 4H5C4.44772 4 4 4.44772 4 5V15C4 15.5523 4.44772 16 5 16H10V5C10 4.44772 9.55228 4 9 4ZM15 6H13C12.4477 6 12 6.44772 12 7V16H15C15.5523 16 16 15.5523 16 15V7C16 6.44772 15.5523 6 15 6ZM8 13C8.55228 13 9 13.4477 9 14C9 14.5523 8.55228 15 8 15H6C5.44772 15 5 14.5523 5 14C5 13.4477 5.44772 13 6 13H8ZM8 9C8.55228 9 9 9.44772 9 10C9 10.5523 8.55228 11 8 11H6C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9H8ZM8 5C8.55228 5 9 5.44772 9 6C9 6.55228 8.55228 7 8 7H6C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5H8Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-folder': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 4C1 2.94564 1.81588 2.08183 2.85074 2.00549L3 2H8.10773C9.10187 2 10.0436 2.44606 10.6733 3.21529L12.953 6H17C18.1046 6 19 6.89543 19 8V16C19 17.1046 18.1046 18 17 18H3C1.89543 18 1 17.1046 1 16V4ZM3 16H17V8H3V16ZM8.10773 4H3V6H10.368L9.12582 4.48226C8.90715 4.21517 8.59372 4.04626 8.25449 4.0082L8.10773 4Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-calendar': {
    code: (
      <>
        <g clipPath="url(#clip0_11_871)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 0.221313C15.5523 0.221313 16 0.718775 16 1.33242V2.44354H17C18.1046 2.44354 19 3.43846 19 4.66576V17.9991C19 19.2264 18.1046 20.2213 17 20.2213H3C1.89543 20.2213 1 19.2264 1 17.9991V4.66576C1 3.43846 1.89543 2.44354 3 2.44354H4V1.33242C4 0.718775 4.44772 0.221313 5 0.221313C5.55228 0.221313 6 0.718775 6 1.33242V2.44354H14V1.33242C14 0.718775 14.4477 0.221313 15 0.221313ZM17 9.1102H3V17.9991H17V9.1102ZM17 4.66576H3V6.88798H17V4.66576Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_11_871">
            <rect width={20} height={20} fill="white" />
          </clipPath>
        </defs>
      </>
    ),
    size: 20,
  },
  '20-close': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.414 10L15.707 5.70701C16.098 5.31601 16.098 4.68401 15.707 4.29301C15.316 3.90201 14.684 3.90201 14.293 4.29301L10 8.58601L5.70701 4.29301C5.31601 3.90201 4.68401 3.90201 4.29301 4.29301C3.90201 4.68401 3.90201 5.31601 4.29301 5.70701L8.58601 10L4.29301 14.293C3.90201 14.684 3.90201 15.316 4.29301 15.707C4.48801 15.902 4.74401 16 5.00001 16C5.25601 16 5.51201 15.902 5.70701 15.707L10 11.414L14.293 15.707C14.488 15.902 14.744 16 15 16C15.256 16 15.512 15.902 15.707 15.707C16.098 15.316 16.098 14.684 15.707 14.293L11.414 10Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-checkOutline': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0ZM9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2ZM12.555 5.16832C13.014 5.47532 13.138 6.09532 12.832 6.55532L8.832 12.5553C8.666 12.8043 8.396 12.9663 8.099 12.9953C8.065 12.9983 8.033 13.0003 8 13.0003C7.736 13.0003 7.481 12.8963 7.293 12.7073L5.293 10.7073C4.902 10.3163 4.902 9.68432 5.293 9.29332C5.684 8.90232 6.316 8.90232 6.707 9.29332L7.845 10.4313L11.168 5.44532C11.474 4.98532 12.094 4.86132 12.555 5.16832Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-customerOrders': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h14Zm0 2H2v4h14V2ZM16 10a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14Zm0 2H2v4h14v-4Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-table': {
    code: (
      <path
        d="M18 16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V2C0 0.89543 0.89543 0 2 0H16C17.1046 0 18 0.89543 18 2V16ZM2 12.999V16H5V12.999H2ZM7 12.999V16H16V13L7 12.999ZM7 6.999V10.999L16 11V7L7 6.999ZM5 6.999H2V10.999H5V6.999ZM16 2H7V4.999L16 5V2ZM5 2H2V4.999H5V2Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-timeline': {
    code: (
      <path
        d="M3 0C3.55228 0 4 0.447715 4 1L4.0009 2.17102C5.16562 2.58311 6 3.69412 6 5C6 6.30588 5.16562 7.41688 4.0009 7.82898V10.171C5.16562 10.5831 6 11.6941 6 13C6 14.3059 5.16562 15.4169 4.0009 15.829L4 17C4 17.5523 3.55228 18 3 18C2.44772 18 2 17.5523 2 17L2.00009 15.8293C0.83485 15.4175 0 14.3063 0 13C0 11.6937 0.83485 10.5825 2.00009 10.1707V7.82933C0.83485 7.41751 0 6.30625 0 5C0 3.69375 0.83485 2.58249 2.00009 2.17067L2 1C2 0.447715 2.44772 0 3 0ZM16 10C17.1046 10 18 10.8954 18 12V14C18 15.1046 17.1046 16 16 16H10C8.89543 16 8 15.1046 8 14V12C8 10.8954 8.89543 10 10 10H16ZM3 12C2.44772 12 2 12.4477 2 13C2 13.5523 2.44772 14 3 14C3.55228 14 4 13.5523 4 13C4 12.4477 3.55228 12 3 12ZM16 12H10V14H16V12ZM16 2C17.1046 2 18 2.89543 18 4V6C18 7.10457 17.1046 8 16 8H10C8.89543 8 8 7.10457 8 6V4C8 2.89543 8.89543 2 10 2H16ZM3 4C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6C3.55228 6 4 5.55228 4 5C4 4.44772 3.55228 4 3 4ZM16 4H10V6H16V4Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-users': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 12a5.006 5.006 0 0 1 4.995 4.783L16 17v2H4v-2c0-2.757 2.243-5 5-5h2Zm0 2H9c-1.654 0-3 1.346-3 3h8a3.004 3.004 0 0 0-2.824-2.995L11 14ZM5.432 9.033c.35.784.896 1.46 1.575 1.969L6 11c-1.654 0-3 1.346-3 3h.805a5.96 5.96 0 0 0-.722 2H1v-2a5.008 5.008 0 0 1 4.357-4.959l.075-.008Zm9.136 0a5.006 5.006 0 0 1 4.427 4.75L19 14v2h-2.085a5.994 5.994 0 0 0-.724-2H17a3.004 3.004 0 0 0-2.824-2.995L14 11l-1.004.001a5.028 5.028 0 0 0 1.572-1.968ZM10 3c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4Zm0 2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2Zm3.5-4C15.43 1 17 2.57 17 4.5c0 1.412-.84 2.632-2.048 3.184a4.98 4.98 0 0 0-.227-2.32 1.502 1.502 0 0 0-1.648-2.303 4.987 4.987 0 0 0-2.114-.968A3.483 3.483 0 0 1 13.5 1Zm-7 0c.998 0 1.9.42 2.538 1.092a4.986 4.986 0 0 0-2.116.97 1.502 1.502 0 0 0-1.648 2.303 4.984 4.984 0 0 0-.227 2.319A3.505 3.505 0 0 1 3 4.5C3 2.57 4.57 1 6.5 1Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-wishlist': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14ZM3 13.999V17h3v-3.001H3Zm5 0V17h9v-3l-9-.001Zm0-6v4L17 12V8l-9-.001Zm-2 0H3v4h3v-4ZM17 3H8v2.999L17 6V3ZM6 3H3v2.999h3V3Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-reports': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 17h14V3H3v14ZM17 1H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2ZM6 9a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm4-4a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1Zm4 6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-createUser': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 12v2H6c-1.654 0-3 1.346-3 3h6v2H1v-2c0-2.757 2.243-5 5-5h3Zm6-1a1 1 0 0 1 .993.883L16 12v2h2a1 1 0 0 1 .117 1.993L18 16h-2v2a1 1 0 1 1-2 0v-2h-2l-.117-.007a1 1 0 0 1 0-1.986L12 14h2v-2l.007-.117A1 1 0 0 1 15 11ZM10 1c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5Zm0 2C8.346 3 7 4.346 7 6s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-chevron-left': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.293 10.707a1 1 0 0 1-.083-1.32l.083-.094 6-6a1 1 0 0 1 1.497 1.32l-.083.094L8.415 10l5.292 5.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083-6-6Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-chevron-right': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.707 9.293a1 1 0 0 1 .083 1.32l-.083.094-6 6a1 1 0 0 1-1.497-1.32l.083-.094L11.585 10 6.293 4.707a1 1 0 0 1-.083-1.32l.083-.094a1 1 0 0 1 1.32-.083l.094.083 6 6Z"
        fill="currentColor"
      />
    ),
    size: 20,
  },
  '20-double-chevron-right': {
    code: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7071 9.29289C11.0676 9.65338 11.0953 10.2206 10.7903 10.6129L10.7071 10.7071L4.70711 16.7071C4.31658 17.0976 3.68342 17.0976 3.29289 16.7071C2.93241 16.3466 2.90468 15.7794 3.2097 15.3871L3.29289 15.2929L8.585 10L3.29289 4.70711C2.93241 4.34662 2.90468 3.77939 3.2097 3.3871L3.29289 3.29289C3.65338 2.93241 4.22061 2.90468 4.6129 3.2097L4.70711 3.29289L10.7071 9.29289Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7071 9.29289C17.0676 9.65338 17.0953 10.2206 16.7903 10.6129L16.7071 10.7071L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071C8.93241 16.3466 8.90468 15.7794 9.2097 15.3871L9.29289 15.2929L14.585 10L9.29289 4.70711C8.93241 4.34662 8.90468 3.77939 9.2097 3.3871L9.29289 3.29289C9.65338 2.93241 10.2206 2.90468 10.6129 3.2097L10.7071 3.29289L16.7071 9.29289Z"
          fill="currentColor"
        />
      </>
    ),
    size: 20,
  },
  '20-import-logs': {
    code: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1L17 6V17C17 18.1046 16.1046 19 15 19H5C3.89543 19 3 18.1046 3 17V3C3 1.89543 3.89543 1 5 1H12ZM11 3H5V17H15V7H11V3Z"
          fill="currentColor"
        />
        <path
          d="M10 9C10.5523 9 11 9.44772 11 10V13.585L12.2929 12.2929C12.6834 11.9024 13.3166 11.9024 13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071L6.29289 13.7071C5.90237 13.3166 5.90237 12.6834 6.29289 12.2929C6.68342 11.9024 7.31658 11.9024 7.70711 12.2929L9 13.585V10C9 9.44772 9.44772 9 10 9Z"
          fill="currentColor"
        />
      </>
    ),
    size: 20,
  },
  '20-double-chevron-left': {
    code: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.29289 10.7073C8.93239 10.3468 8.90469 9.77958 9.20969 9.38728L9.29289 9.29308L15.2929 3.29308C15.6834 2.90258 16.3166 2.90258 16.7071 3.29308C17.0676 3.65358 17.0953 4.22078 16.7903 4.61308L16.7071 4.70728L11.415 10.0002L16.7071 15.2931C17.0676 15.6536 17.0953 16.2208 16.7903 16.6131L16.7071 16.7073C16.3466 17.0678 15.7794 17.0955 15.3871 16.7905L15.2929 16.7073L9.29289 10.7073Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.2929 10.7073C2.9324 10.3468 2.9047 9.77958 3.2097 9.38728L3.2929 9.29308L9.29289 3.29308C9.68339 2.90258 10.3166 2.90258 10.7071 3.29308C11.0676 3.65358 11.0953 4.22078 10.7903 4.61308L10.7071 4.70728L5.415 10.0002L10.7071 15.2931C11.0676 15.6536 11.0953 16.2208 10.7903 16.6131L10.7071 16.7073C10.3466 17.0678 9.7794 17.0955 9.3871 16.7905L9.29289 16.7073L3.2929 10.7073Z"
          fill="currentColor"
        />
      </>
    ),
    size: 20,
  },
};

export const icons24: Icons = {
  '24-delete': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 10V16C16 17.1046 15.1046 18 14 18H10C8.89543 18 8 17.1046 8 16V10H16ZM13.5 6L14.5 7H16C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9H8C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7H9.5L10.5 6H13.5Z"
        fill="currentColor"
      />
    ),
    size: 24,
  },
  '24-picking': {
    code: (
      <>
        <path
          d="M7.47046 9.24307L7.47355 9.23935L7.53594 9.1687L7.53922 9.1652C7.83753 8.86688 8.30684 8.844 8.6315 9.09643L8.63521 9.09952L8.70586 9.16191L8.70936 9.1652L10.9594 11.4152L10.961 11.4169L10.992 11.4498L10.9957 11.4541L11.0371 11.5049L11.0421 11.5119L11.0959 11.5953L11.1008 11.6041L11.1408 11.6886L11.1443 11.6971L11.1708 11.7761L11.1734 11.7859L11.1951 11.8968L11.1964 11.9072L11.2016 11.9957L11.2017 12.0031L11.1996 12.0596L11.1989 12.0674L11.1858 12.1615L11.184 12.1706L11.1618 12.2542L11.159 12.2628L11.126 12.3462L11.1223 12.3543L11.083 12.4274L11.0781 12.4353L11.0229 12.5139L11.0172 12.521L10.9623 12.5823L10.9594 12.5853L8.70936 14.8353C8.38624 15.1585 7.86234 15.1585 7.53922 14.8353C7.2409 14.537 7.21803 14.0677 7.47046 13.7431L7.47355 13.7393L7.53594 13.6687L7.5392 13.6652L8.37621 12.8277H3.87429C3.41732 12.8277 3.04688 12.4572 3.04688 12.0003C3.04688 11.5433 3.41732 11.1728 3.87429 11.1728H8.37621L7.53922 10.3353C7.53923 10.3353 7.53921 10.3353 7.53922 10.3353C7.24092 10.037 7.21803 9.56772 7.47046 9.24307Z"
          fill="#0071CE"
        />
        <path
          d="M7.53922 10.3353L8.37621 11.1728H3.87429C3.41732 11.1728 3.04688 11.5433 3.04688 12.0003C3.04688 12.4572 3.41732 12.8277 3.87429 12.8277H8.37621L7.5392 13.6652L7.53594 13.6687L7.47355 13.7393L7.47046 13.7431C7.21803 14.0677 7.2409 14.537 7.53922 14.8353C7.86234 15.1585 8.38624 15.1585 8.70936 14.8353L10.9594 12.5853L10.9623 12.5823L11.0172 12.521L11.0229 12.5139L11.0781 12.4353L11.083 12.4274L11.1223 12.3543L11.126 12.3462L11.159 12.2628L11.1618 12.2542L11.184 12.1706L11.1858 12.1615L11.1989 12.0674L11.1996 12.0596L11.2017 12.0031L11.2016 11.9957L11.1964 11.9072L11.1951 11.8968L11.1734 11.7859L11.1708 11.7761L11.1443 11.6971L11.1408 11.6886L11.1008 11.6041L11.0959 11.5953L11.0421 11.5119L11.0371 11.5049L10.9957 11.4541L10.992 11.4498L10.961 11.4169L10.9594 11.4152L8.70936 9.1652L8.70586 9.16191L8.63521 9.09952L8.6315 9.09643C8.30684 8.844 7.83753 8.86688 7.53922 9.1652L7.53594 9.1687L7.47355 9.23935L7.47046 9.24307C7.21803 9.56772 7.24092 10.037 7.53922 10.3353ZM7.53922 10.3353C7.53921 10.3353 7.53923 10.3353 7.53922 10.3353Z"
          fill="#0071CE"
        />
        <path
          d="M22.4446 8.70294C22.4446 8.59848 22.3924 8.54625 22.3402 8.49402L18.1095 6.03917C18.0572 5.98694 17.9528 5.98694 17.8483 6.03917L13.5654 8.49402C13.5132 8.54625 13.4609 8.59848 13.4609 8.70294C13.4609 8.8074 13.5132 8.85963 13.5654 8.91186L17.7961 11.3667C17.8483 11.3667 17.9005 11.4189 17.9005 11.4189C17.9005 11.4189 18.005 11.4189 18.005 11.3667L22.2357 8.91186C22.3924 8.85963 22.4446 8.75517 22.4446 8.70294Z"
          fill="#0071CE"
        />
        <path
          d="M17.2213 12.62L12.9906 10.1651C12.8862 10.1129 12.7817 10.1129 12.7295 10.1651C12.6772 10.2174 12.625 10.3218 12.625 10.3741V15.2838C12.625 15.3882 12.6772 15.4404 12.7295 15.4927L16.9601 17.9475C17.0124 17.9475 17.0646 17.9998 17.0646 17.9998C17.0646 17.9998 17.1691 17.9998 17.1691 17.9475C17.2213 17.8953 17.2735 17.8431 17.2735 17.7386V12.8289C17.378 12.7244 17.3258 12.6722 17.2213 12.62Z"
          fill="#0071CE"
        />
        <path
          d="M23.1744 10.1651C23.1222 10.1129 23.0177 10.1129 22.9132 10.1651L18.6826 12.62C18.6303 12.6722 18.5781 12.7244 18.5781 12.8289V17.7386C18.5781 17.8431 18.6303 17.8953 18.6826 17.9475C18.7348 17.9475 18.787 17.9998 18.787 17.9998C18.787 17.9998 18.8915 17.9998 18.8915 17.9475L23.1222 15.4927C23.1744 15.4404 23.2266 15.3882 23.2266 15.2838V10.3741C23.2789 10.3218 23.2266 10.2174 23.1744 10.1651Z"
          fill="#0071CE"
        />
      </>
    ),
    size: 24,
  },
};

export const icons40: Icons = {
  '40-listUnordered': {
    code: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8h22a2 2 0 1 0 0-4H14a2 2 0 1 0 0 4Zm0 14h22a2 2 0 1 0 0-4H14a2 2 0 1 0 0 4Zm-9 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm31 1a2 2 0 1 1 0 4H14a2 2 0 1 1 0-4h22ZM5 17a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM5 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
        fill="currentColor"
      />
    ),
    size: 40,
  },
};

export const flags: Icons = {
  '16-de': {
    code: (
      <>
        <path d="M0 10h16v4H0v-4Z" fill="#FFCE00" />
        <path d="M0 2h16v4H0V2Z" fill="#000" />
        <path d="M0 6h16v4H0V6Z" fill="#D00" />
      </>
    ),
    size: 16,
  },
};

export const icons: Icons = {
  ...icons8,
  ...icons12,
  ...icons16,
  ...icons18,
  ...icons20,
  ...icons24,
  ...icons40,
  ...flags,
};
